import {getAxios,postAxios,toastMsg} from '../utils/ApiHelper';

class RegisterService {

  setRegisterFormData(payload,file_flg) {
    return postAxios("userevent/add-user", payload,file_flg)
      .then(response => {
        if(response){
          toastMsg('Thank you for registration!','success');
        }
        return response;
      });
  }

  getEvents(id) {
    // return true;
    return getAxios(`event/get/${id}`)
      .then(response => {
        return response.data;
      });
  }


}

export default new RegisterService();
